'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSCombo(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsszoom',
        template: require("./bsscombo.html"),
        controller: ["$scope", "$filter", "$timeout", "$http", "ErrorManager", "DSFactory", require("./BssComboController")],
        defaultOptions: {
            defaultValue: null,
            ngModelElAttrs: {
                'cssCategory': 'bsscombo'
            },
        }
    }));
}

module.exports = BSSCombo;